<template>
    <layout-horizontal>
        <router-view v-if="tabs === 0 || isMobile" />
        <router-tab
            v-if="tabs === 1 && !isMobile"
            :i18n="i18n"
            :contextmenu="false"
        />
        <template #customizer>
            <app-customizer v-if="showCustomizer" />
        </template>
    </layout-horizontal>
</template>

<script>
import { getUserData } from '@/auth/utils'
import AppCustomizer from '@core/layouts/components/app-customizer/AppCustomizer.vue'
import LayoutHorizontal from '@core/layouts/layout-horizontal/LayoutHorizontal.vue'
import { $themeConfig } from '@themeConfig'
import { isMobile } from 'mobile-device-detect'

export default {
    name: 'horizontal-layout',
    components: {
        LayoutHorizontal,
        AppCustomizer,
    },
    data() {
        return {
            isMobile,
            tabs: getUserData().tabs,
            showCustomizer: $themeConfig.layout.customizer,
        }
    },
    methods: {
        i18n(key, params) {
            // $getI18n() is the global method for internationalization in real projects
            return this.$t(key, params)
        },
    },
}
</script>
